import { Loader } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { useAuth } from "../../../context/Auth/AuthContext";
import { API } from "../../../services/apiService";

const LinkedInCallback = () => {
	const [isLoading, setIsLoading] = useState(true);

	const queryParams = new URLSearchParams(window.location.search);
	const code = queryParams.get("code");

	const navigate = useNavigate();
	const { setSession } = useAuth();

	useEffect(() => {
		const fetchLinkedInData = async () => {
			if (code) {
				try {
					const { data } = await API.post("auth/linkedin", {
						authCode: code,
						source: "WEB",
					});

					if (data.access_token) {
						const expiresAt = new Date(Date.now() + data.expires_in * 1000);
						const token = data.access_token.startsWith("LI::") ? data.access_token : `LI::${data.access_token}`;
						setSession({ token, expiresAt });

						navigate("/profile", { replace: true });
					} else {
						toast.error("LinkedIn login failed");
						navigate("/signin");
					}
				} catch {
					toast.error("LinkedIn login failed");
					navigate("/signin");
				} finally {
					setIsLoading(false);
				}
			}
		};

		fetchLinkedInData();
	}, [code, navigate, setSession]);

	return <div className="hidden">{isLoading ? <Loader /> : null}</div>;
};

export default LinkedInCallback;
